<template>
  <v-app>
    <!-- <v-img :src="background"> -->
      <Toolbar/>
      <v-content>
        <Schools v-if="view"/>
        <Projects v-else/>
      </v-content>
      <Footer/>
    <!-- </v-img> -->
  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar'
import Schools from './components/Schools'
import Projects from './components/Projects'
import Footer from './components/Footer'

export default {
  name: 'App',

  components: {
    Toolbar,
    Schools,
    Projects,
    Footer
  },

  data: () => ({
    // background: require('./assets/background.png')
  }),

  computed: {
    view: {
      get () {
        return this.$store.state.view
      }
    }
  },
};
</script>
